// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qQAcech9fynsGfZTwG07.KsGnzNEwEUy7VnWh4SXc{padding:.5rem 1rem}`, "",{"version":3,"sources":["webpack://./src/components/license-history/LicenseHistoryCard/styles.module.sass"],"names":[],"mappings":"AAEA,2CACE,kBAAA","sourcesContent":["@import \"src/assets/sass/base/_spacing.sass\"\n\n.card.current\n  padding: $spacing-xs $spacing-sm\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `qQAcech9fynsGfZTwG07`,
	"current": `KsGnzNEwEUy7VnWh4SXc`
};
export default ___CSS_LOADER_EXPORT___;
